import React from 'react';
import { CoachCard } from '../../components/CoachCard';
export function StartFreeCoaches() {
  return <section className="py-24 bg-paper border-t border-subtle-gray" data-id="element-3075">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3076">
        <h2 className="text-4xl text-ink text-center mb-16" data-id="element-3077">
          Meet the Coaches
        </h2>
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-3078">
          <CoachCard name="Shane Merem" role="Owner / Team Storm Coach" bio="Instills grit, confidence, determination, and discipline in every student." comingSoon data-id="element-3079" />
          <CoachCard name="Megan Merem" role="Chief Instructor" bio="Two-time USA National Sparring Champion. Creates a friendly but firm learning environment." comingSoon data-id="element-3080" />
          <CoachCard name="Michael Jacobs" role="Instructor" bio="USAT National Gold Medalist dedicated to student success." comingSoon data-id="element-3081" />
        </div>
      </div>
    </section>;
}